import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-login-term-and-condition',
  templateUrl: './login-term-and-condition.component.html',
  styleUrls: ['./login-term-and-condition.component.scss']
})
export class LoginTermAndConditionComponent {

  environment = environment;
  checked = false;
  constructor(
    public dialogRef: MatDialogRef<LoginTermAndConditionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  login(){
    window.location.href = environment.aimURL;
  }
}
